<template>
  <div>
    <section class="section">
      <div class="container" style="padding-top:50px;">
        <div class="columns is-multiline">
          <div class="column is-12">
            <h1 class="title">Übersicht</h1>
          </div>

          <div class="column is-12">
            <table class="table is-bordered is-hoverable is-striped is-narrow is-fullwidth">
              <thead>
                <tr>
                  <th>Aktiv</th>
                  <th>Headline</th>
                  <th>Title</th>
                  <th>Path</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(i, index) in overview" :key="index">
                  <td>
                    <a @click="activation(i.id, i.seo.niceUrl)">
                      <span class="icon">
                        <i :class="[i.active ? 'fas fa-check-circle' : 'far fa-circle']"></i>
                      </span>
                    </a>
                  </td>
                  <td>
                    <router-link :to="'/cms/edit/' + i.id">{{ i.headline }}</router-link>
                  </td>
                  <td>{{ i.seo.title }}</td>
                  <td>/details/{{ i.seo.niceUrl }}</td>
                  <td>
                    <a @click="deleteContent(i.id)">
                      <span class="icon">
                        <i class="fas fa-trash-alt"/>
                      </span>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      overview: []
    }
  },
  metaInfo: {
    meta: [{ name: 'robots', content: 'NOINDEX, NOFOLLOW' }]
  },
  methods: {
    // SSRcontent(path) {
    //   const rtoken = localStorage.getItem('rtoken')
    //   const rid = localStorage.getItem('rid')
    //   if (rtoken && rid && path) {
    //     axios
    //       .put(
    //         'https://api.roast.io/api/v1/sites/' + rid + '/ssr',
    //         { paths: ['/details/' + path] },
    //         { headers: { Authorization: 'Bearer ' + rtoken } }
    //       )
    //       .then(response => {
    //         console.log('SSR success: ' + path)
    //       })
    //       .catch(error => {
    //         console.log(error)
    //       })
    //   }
    // },
    activation(v, url) {
      const vm = this
      axios
        .put('/content/activation/' + v)
        .then(function(response) {
          // vm.SSRcontent(url)
          vm.getOverview()
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    deleteContent(v) {
      if (confirm('Sind Sie sich sicher?') === true) {
        const vm = this
        axios
          .delete('/content/' + v)
          .then(function(response) {
            vm.getOverview()
          })
          .catch(function(error) {
            console.log(error)
          })
      }
    },
    getOverview() {
      const vm = this
      axios
        .get('/content/overview')
        .then(function(res) {
          vm.overview = res.data
        })
        .catch(function(error) {
          console.log(error)
        })
    }
  },
  created() {
    this.getOverview()
  }
}
</script>

<style>
</style>
